// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1SuBQ","content":"LayoutSettings_content___ntA8"};